import type { ReactNode } from "react"
import { Modal } from "./Modal.tsx"

/** A yes/no question in the app's style (never the browser's confirm()). */
export function ConfirmDialog({ busy = false, children, confirmLabel, danger = false, error, onCancel, onConfirm, title }: {
  readonly title: string
  readonly children: ReactNode
  readonly confirmLabel: string
  readonly onConfirm: () => void
  readonly onCancel: () => void
  readonly danger?: boolean
  readonly busy?: boolean
  readonly error?: string | null | undefined
}) {
  return (
    <Modal title={title} onClose={onCancel}>
      <div className="settings-form confirm-body">
        {children}
        {error && <p className="form-error">{error}</p>}
        <footer className="settings-actions">
          <span className="toolbar-spacer" />
          <button type="button" onClick={onCancel}>Cancel</button>
          <button type="button" className={danger ? "danger" : "primary"} disabled={busy} onClick={onConfirm}>
            {busy ? "Working…" : confirmLabel}
          </button>
        </footer>
      </div>
    </Modal>
  )
}
